import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup';
import { useNavigate, useParams, Link } from 'react-router-dom'
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Breadcrumbs from '@mui/material/Breadcrumbs';

import { isValidFileUploaded } from '../../../utils/isValidFileUploaded';
import Loader from '../../Loader/Loader';
import './AdminPlacementCarousel.css'

const ADMIN_PLACEMENT_CAROUSEL_URL = 'admin/auth/placement-carousel'

const PlacementCarouselSchema = Yup.object().shape({
    student_name: Yup.string()
        .min(3, 'Title too short')
        .max(55, 'Title too long')
        .required('Required'),
    student_batch: Yup.string()
        .required('Required'),
    company_name: Yup.string()
        .required('Required'),
    company_website: Yup.string()
        .required('Required'),
    package: Yup.string(),
    placement_type: Yup.string()
        .required('Required'),
    updated_company_logo: Yup.string()
        .required('Required'),
    updated_image: Yup.string()
        .nullable(),
    order_no: Yup.number().positive('Only positive numbers')
        .required('Required'),
});


const UpdatePlacementCarousel = () => {
    const { id } = useParams()
    const navigate = useNavigate()
    const token = localStorage.getItem('token')
    const [placementCarousel, setPlacementCarousel] = useState([])
    const [gettingData, setGettingdata] = useState(true)
    const [loading, setLoading] = useState(false)

    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const deletePlacementCarousel = async (id) => {
        try {
            await axios.delete(`${process.env.REACT_APP_DEPT_API}/${ADMIN_PLACEMENT_CAROUSEL_URL}/${id}/delete`, {
                headers: {
                    authorization: `Bearer ${token}`
                }
            })
            alert("Deleted successfully")
            navigate('/admin/placement-carousel')
        } catch (err) {
            console.log(err)
            alert("Error, check console logs")
        }
    }


    useEffect(() => {
        setGettingdata(true)
        const getData = async () => {
            try {
                const response = await axios.get(process.env.REACT_APP_DEPT_API + '/placement-carousel/' + id)
                setPlacementCarousel(response.data)
                setGettingdata(false)
            } catch (err) {
                console.log(err)
                alert("Error, check console logs")
            }
        }
        getData()
        // eslint-disable-next-line
    }, [])
    return (
        <div className='admin'>
            <div className='section__container'>
                <div className='section'>
                    <Breadcrumbs aria-label="breadcrumb">
                        <Link to="/admin" className='breadcrumb__link'>
                            Admin
                        </Link>
                        <Link to="/admin/placement-carousel" className='breadcrumb__link'>
                            Placement Carousel   
                        </Link>
                        <Link to="" className='breadcrumb__link bold'>
                            Update
                        </Link>
                    </Breadcrumbs>
                </div>
                <div className='section'>
                    <h3 className='section__header'>Update Placement Carousel</h3>
                    {!gettingData ?
                        <div className='updateFacility'>
                            <button className='admin_delete_btn' variant="outlined" onClick={handleClickOpen}>
                                Delete
                            </button>
                            <Dialog open={open} onClose={handleClose}>
                                <DialogTitle>
                                    <span className='admin_modal_header'>Confirm Delete</span>
                                </DialogTitle>
                                <DialogContent>
                                    <div className='modal_btn_container'>
                                        <button className='admin_modal_btn cancel' onClick={handleClose}>Cancel</button>
                                        <button className='admin_modal_btn delete' onClick={() => deletePlacementCarousel(id)}>Delete</button>
                                    </div>
                                </DialogContent>

                            </Dialog>
                            <Formik
                                initialValues={{ ...placementCarousel, updated_image: null }}
                                validationSchema={PlacementCarouselSchema}
                                enableReinitialize={true}
                                onSubmit={async (data) => {
                                    setLoading(true)
                                    axios.put(`${process.env.REACT_APP_DEPT_API}/${ADMIN_PLACEMENT_CAROUSEL_URL}/${id}/update`, data, {
                                        headers: {
                                            authorization: `Bearer ${token}`
                                        }
                                    }).then(() => {
                                        setLoading(false)
                                        alert("Updated successfully")
                                        navigate('/admin/placement-carousel')
                                    }).catch(err => {
                                        console.log(err)
                                        alert("Error occured. Check console logs")
                                    })
                                }}
                            >
                                {({ errors, values, setFieldValue }) => (
                                    <Form className='admin_form_container'>
                                        <div className='admin_input_container'>
                                            <p className='admin_label'>Student Name* </p>
                                            <label htmlFor="student_name">
                                                <Field className='admin_input' id="student_name" name="student_name" />
                                            </label>
                                            <p className='admin_error_msg'>{errors.student_name}</p>
                                        </div>
                                        <div className='admin_input_container'>
                                            <p className='admin_label'>Student Batch* </p>
                                            <label htmlFor="student_batch">
                                                <Field className='admin_input' id="student_batch" name="student_batch" />
                                            </label>
                                            <p className='admin_error_msg'>{errors.student_batch}</p>
                                        </div>
                                        <div className='admin_input_container'>
                                            <p className='admin_label'>Company Name* </p>
                                            <label htmlFor="company_name">
                                                <Field className='admin_input' id="company_name" name="company_name" />
                                            </label>
                                            <p className='admin_error_msg'>{errors.company_name}</p>
                                        </div>
                                        <div className='admin_input_container'>
                                            <p className='admin_label'>Company Website* </p>
                                            <label htmlFor="company_website">
                                                <Field className='admin_input' id="company_website" name="company_website" />
                                            </label>
                                            <p className='admin_error_msg'>{errors.company_website}</p>
                                        </div>
                                        <div className='admin_input_container'>
                                            <p className='admin_label'>Package </p>
                                            <label htmlFor="package">
                                                <Field className='admin_input' id="package" name="package" />
                                            </label>
                                            <p className='admin_error_msg'>{errors.package}</p>
                                        </div>
                                        <div className='admin_input_container'>
                                            <p className='admin_label'>Placement Type* </p>
                                            <label htmlFor="placement_type">
                                                <Field as="select" className='admin_input' id="placement_type" name="placement_type" >
                                                    <option value="placement">Placement</option>
                                                    <option value="internship">Internship</option>
                                                </Field>
                                            </label>
                                            <p className='admin_error_msg'>{errors.placement_type}</p>
                                        </div>
                                        <div className='admin_input_container'>
                                            {placementCarousel.image && (
                                                <div className='img_upload_preview'>
                                                    <img src={placementCarousel && placementCarousel.image && placementCarousel.image.url} alt="logo" style={{ width: "200px" }} />
                                                </div>
                                            )}
                                            <p className='admin_label' htmlFor="updated_image">Change Student Image </p>
                                            <p className='admin_label_small' htmlFor="image">Allowed formats: [.png, .jpeg, .jpg, .svg, .ico, .jfif, .webp] </p>
                                            <p className='admin_label_small' htmlFor="image">Max size: 10MB </p>
                                            <label>
                                                <input className='admin_input' id="file" name="updated_image" type="file" onChange={(e) => {
                                                    // converting updated_image to base64 for cloudinary
                                                    const file = e.target.files[0]
                                                    if (isValidFileUploaded(file)) {
                                                        const reader = new FileReader()
                                                        reader.readAsDataURL(file)
                                                        reader.onloadend = () => {
                                                            setFieldValue("updated_image", reader.result)
                                                        }
                                                    } else {
                                                        alert('Invalid file type / Size limit exceeded')
                                                        e.target.value = null;
                                                    }
                                                }} />
                                            </label>
                                            <p className='admin_error_msg'>{errors.image}</p>
                                        </div>
                                        <div className='admin_input_container'>
                                            {placementCarousel.company_logo && (
                                                <div className='img_upload_preview'>
                                                    <img src={placementCarousel && placementCarousel.company_logo && placementCarousel.company_logo.url} alt="logo" style={{ width: "150px" }} />
                                                </div>
                                            )}
                                            <p className='admin_label' htmlFor="updated_company_logo">Change Company logo </p>
                                            <p className='admin_label_small' htmlFor="updated_company_logo">Allowed formats: [.png, .jpeg, .jpg, .svg, .ico, .jfif, .webp] </p>
                                            <p className='admin_label_small' htmlFor="updated_company_logo">Max size: 10MB </p>
                                            <label>
                                                <input className='admin_input' id="file" name="updated_company_logo" type="file" onChange={(e) => {
                                                    // converting updated_company_logo to base64 for cloudinary
                                                    const file = e.target.files[0]
                                                    if (isValidFileUploaded(file)) {
                                                        const reader = new FileReader()
                                                        reader.readAsDataURL(file)
                                                        reader.onloadend = () => {
                                                            setFieldValue("updated_company_logo", reader.result)
                                                        }
                                                    } else {
                                                        alert('Invalid file type / Size limit exceeded')
                                                        e.target.value = null;
                                                    }
                                                }} />
                                            </label>
                                            <p className='admin_error_msg'>{errors.updated_company_logo}</p>
                                        </div>
                                        <div className='admin_input_container'>
                                            <p className='admin_label'>Order Number* </p>
                                            <label htmlFor="order_no">
                                                <input className='admin_input' type="number" id="order_no" name="order_no" value={values.order_no} onChange={e => {
                                                    setFieldValue("order_no", Number(e.target.value))
                                                }} />
                                            </label>
                                            <p className='admin_error_msg'>{errors.order_no}</p>
                                        </div>
                                        <button disabled={loading ? true : false} className='admin_btn' type="submit">
                                            {loading ? "Updating..." : "Update"}
                                        </button>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                        : <Loader color="#AE9142" size={80} />}
                </div>
            </div>
        </div>
    )
}

export default UpdatePlacementCarousel